// Product Added SuccessFull
export const ADD_TO_CART = "ADD_TO_CART";

// Remove form cart
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
